module.exports = __webpack_public_path__ + "img/algolia-blue-mark.8cc5351.svg";